import React, { useState, useEffect } from 'react';

const AssistantLauncher = ({ onClick, showAlert, userPlan }) => {
  // Mensajes base
  const baseTips = [
    "¿Te ayudo?",
    "Accede a tutoriales para aprender más",
    "Explora las funciones del dashboard"
  ];

  // Mensajes personalizados según plan
  let planTip = "";
  if (userPlan === "basic") {
    planTip = "Actualiza a Pro para agregar más de 2 dispositivos";
  } else if (userPlan === "pro") {
    planTip = "¿Sabías que el plan Enterprise permite hasta 100 dispositivos?";
  } else if (userPlan === "enterprise") {
    planTip = "¡Gracias por usar nuestro plan más avanzado!";
  }

  const tips = planTip ? [planTip, ...baseTips] : baseTips;

  const [showTooltip, setShowTooltip] = useState(false);
  const [currentTip, setCurrentTip] = useState(tips[0]);

  // Mostrar tooltip automáticamente al cargar por 3 seg
  useEffect(() => {
    const randomTip = tips[Math.floor(Math.random() * tips.length)];
    setCurrentTip(randomTip);
    setShowTooltip(true);

    const timer = setTimeout(() => setShowTooltip(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // Hover: cambia a un tip aleatorio
  const handleMouseEnter = () => {
    const randomTip = tips[Math.floor(Math.random() * tips.length)];
    setCurrentTip(randomTip);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999 }}>
      <div
        style={{ position: 'relative' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Botón del asistente */}
        <button
          onClick={onClick}
          className="bg-blue-600 text-white rounded-full w-14 h-14 shadow-lg hover:bg-blue-700 flex items-center justify-center text-2xl"
          style={{ cursor: 'pointer' }}
        >
          🤖
        </button>

        {/* Badge rojo de alerta */}
        {showAlert && (
          <div
            style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              background: '#ef4444',
              color: '#fff',
              borderRadius: '50%',
              width: '22px',
              height: '22px',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
          >
            !
          </div>
        )}

        {/* Tooltip dinámico */}
        {showTooltip && (
          <div
            style={{
              position: 'absolute',
              right: '70px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: '#2563eb',
              color: '#fff',
              padding: '8px 12px',
              borderRadius: '6px',
              whiteSpace: 'nowrap',
              fontSize: '14px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              opacity: 1,
              transition: 'opacity 0.3s ease-in-out'
            }}
          >
            {currentTip}
            <div
              style={{
                position: 'absolute',
                right: '-8px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderTop: '6px solid transparent',
                borderBottom: '6px solid transparent',
                borderLeft: '8px solid #2563eb'
              }}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssistantLauncher;
